import { useState } from "react";
import { basicValidation, PublicAmorgUser } from '../../../amorg-common';
import { adminUpdatePassword, changeUserPassword } from "../../../api/userClientApi";
import { MessageCard } from "../../../designSystem/Message";
import { TooltipWrapper } from "../../../designSystem/TooltipWrapper";
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { Icon } from "../../../designSystem/icons/Icons";
import { H2 } from "../../../designSystem/typography/Heading";
import React = require("react");

type FormStatus = 
	{ type:'none' } |
	{ type:'error', message:string } |
	{ type:'success', message:string };

type PasswordEditorProps = {
	selectedUser: PublicAmorgUser
};
export function PasswordEditor({ selectedUser }: PasswordEditorProps): JSX.Element {
	const [oldPW, setOldPW] = useState<string>('');
	const [newPW1, setNewPW1] = useState<string>('');
	const [newPW2, setNewPW2] = useState<string>('');
	const [status, setStatus] = useState<FormStatus>({ type:'none' });

	const handleOnClick = async () => {

		if(!currentPasswordIsValid){
			setStatus({ type:'error', message: 'Nuværende adgangskode skal udfyldes med en valid adgangskode' });
		}
		else if(!newPassword1IsValid){
			setStatus({ type:'error', message: 'Ny adgangskode skal udfyldes med en valid adgangskode på min. 7 karakterer' });
		}
		else if(!newPassword2IsValid){
			setStatus({ type:'error', message: 'Den nye adgangskode er ikke gentaget korrekt' });
		}
		else{
			const result = await changeUserPassword(
				selectedUser.id,
				oldPW,
				newPW1
			);
			if (result.isSuccess) {
				setStatus({ type:'success', message:'Adgangskoden er ændret!'});
				setOldPW('');
				setNewPW1('');
				setNewPW2('');
			}
			else {
				setStatus({ 
					type:'error', 
					message:'Adgangskoden kunne ikke ændres. Dette kan skyldes at den indtastede nuværende adgangskode er forkert, eller at den nye adgangskode ikke er i et gyldigt format.'
				});
			}
		}
	}

	const currentPasswordIsValid = basicValidation.isValidPassword(oldPW);
	const newPassword1IsValid = basicValidation.isValidPassword(newPW1);
	const newPassword2IsValid = newPW2 === newPW1;

	const canSubmit = currentPasswordIsValid && newPassword1IsValid && newPassword2IsValid;

	return (
		<Flex flexDirection="column" gap={8}>
			<H2>Adgangskode</H2>
			{status.type !== 'none' &&
				<MessageCard variant={status.type}>{status.message}</MessageCard>
			}

			<TextField
				label="Nuværende adgangskode"
				type="password"
				validator={() => { return {valid:true}}}
				value={oldPW}
				onChange={(value) => setOldPW(value)} 
                disabled={!selectedUser.enabled} />

			<TextField
				label="Ny adgangskode"
				type="password"
				validator={() => { return {valid:true}}}
				value={newPW1}
				onChange={(value) => setNewPW1(value)} 
                disabled={!selectedUser.enabled} />

			<TextField
				label="Gentag ny adgangskode"
				type="password"
				validator={() => { return {valid:true}}}
				value={newPW2}
				onChange={(value) => setNewPW2(value)}
                disabled={!selectedUser.enabled} />

			<ButtonRow variant="right-aligned">
				<Button
					variant="outlined"
					disabled={!canSubmit || !selectedUser.enabled}
					onClick={handleOnClick}


                    
					text={"Skift adgangskode"} />
			</ButtonRow>
		</Flex>
	);
}

export function AdminPasswordEditor({ selectedUser }: PasswordEditorProps): JSX.Element {
	const [newPW1, setNewPW1] = useState<string>('');
	const [status, setStatus] = useState<FormStatus>({ type:'none' });

	const handleOnClick = async () => {
		if(!newPassword1IsValid){
			setStatus({ type:'error', message: 'Ny adgangskode skal udfyldes med en valid adgangskode' });
		}
		else{
			const result = await adminUpdatePassword(
				selectedUser.id,
				newPW1
			);
			if (result.isSuccess) {
				setStatus({ type:'success', message:'Adgangskoden er ændret!'});
				setNewPW1('');
			}
			else {
				setStatus({ 
					type:'error', 
					message:'Adgangskoden kunne ikke ændres.'
				});
			}
		}
	}

	const newPassword1IsValid = basicValidation.isValidPassword(newPW1);

	const canSubmit = newPassword1IsValid;

	return (
		<Flex flexDirection="column" gap={8}>
            

			<TooltipWrapper tooltip="Som administrator kan du skifte en brugers adgangskode">
				<Flex flexDirection="row" justifyContent="space-between">
					<H2>Skift adgangskode</H2>
					<Icon name="survey_question" />	
				</Flex>
			</TooltipWrapper>
            
			{status.type !== 'none' &&
				<MessageCard variant={status.type}>{status.message}</MessageCard>
			}

			<TextField
				label="Ny adgangskode"
				type="password"
				value={newPW1}
                disabled={!selectedUser.enabled}
				validator={()=>({valid:true})}
				onChange={(value) => setNewPW1(value)} />

			<ButtonRow>
				<Button
					variant="outlined"
					disabled={!canSubmit || !selectedUser.enabled}
					onClick={handleOnClick}
					text={"Skift adgangskode"} />
			</ButtonRow>
		</Flex>

	);
}